import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/api/user/info',
    method: 'post'
  })
}

export const logout = () => {
  return request({
    url: '/api/jwt/InBlacklist',
    method: 'post'
  })
}

export const getUserLoginTimeList = () => {
  return request({
    url: '/api/getUserLoginTimeList',
    method: 'post'
  })
}

export const getLoginTimeList = (data) => {
  return request({
    url: '/api/getLoginTimeList',
    method: 'post',
    data
  })
}

export const getUserList = (data) => {
  return request({
    url: '/api/user/list',
    method: 'post',
    data
  })
}

export const changePassword = (data) => {
  return request({
    url: '/api/user/changePassword',
    method: 'post',
    data
  })
}

export const bingPhoneApi = (data) => {
  return request({
    url: '/api/user/bingPhone',
    method: 'post',
    data
  })
}

export const setUserSystem = (data) => {
  return request({
    url: '/api/user/setUserSystem',
    method: 'post',
    data
  })
}

export const getSubscribe = (data) => {
  return request({
    url: '/api/user/subscribe',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js